import {ProductDataStore} from "../../stores/productDataStore";
import {AccessoryRuleService} from "../../services/accessoryRuleService";
import {AppStateService} from "../../services/appStateService";
import {UIService} from "../UIService";
import {PacketService} from "../packetComponent/packetService";

export class AccessoryService
{
    public static accessoryTypesIds = {
        warmEdgeSpacer: 1,
        fixInFix: 2,
        rollerShutter: 3,
        blind: 4,
        cutForWindowSill: 5,
        slotVentilator: 6,
        hiddenHinges: 7,
        visibleHinges: 8,
        adjufix: 9,
        brakeInHandle: 10,
        selfClosingSystem: 11,
        frictionBrake: 12,
        lowThreshold: 13,
        securitySpanjolett: 14,
        europaCylinder: 15,
        assaCylinder: 16,
        frame: 19,
        universalKey: 20,
        doorHandleAccessory: 21,
        doorEye: 22,
        doorKickplate: 23,
        doorGlazingList: 24,
        other: 25,
    };
    public name: string;
    private productDataStore: ProductDataStore;
    private accessoryRuleService: AccessoryRuleService;
    private appStateService: AppStateService;
    private uiService: UIService;

    constructor()
    {
        this.name = 'accessory';
        this.productDataStore = new ProductDataStore();
        this.accessoryRuleService = new AccessoryRuleService();
        this.appStateService = new AppStateService();
        this.uiService = new UIService();
    }

    public refreshComponentTemplate()
    {
        this.appStateService.setAppSettingTemplateFlag('accessories', 'packetSelectedNotice', PacketService.isAnyPacketSelected());
        this.appStateService.setAppSettingTemplateFlag('accessories', 'showIncludedOptions', this.hasIncludedAccessories());
        this.appStateService.setAppSettingTemplateFlag('accessories', 'showAdditionalOptions', this.hasAdditionalAccessories());
        this.uiService.refreshElementsInModule('accessories');
    }

    public validate()
    {
        const validationResults = this.accessoryRuleService.validate();

        this.productDataStore.updateAccessoryAvailability(validationResults.accessories);

        return validationResults;
    }

    public toggle(id)
    {
        const selectedPacketsAccessories = PacketService.getSelectedPacketsAccessories();
        const selectedAccessory = this.productDataStore.getAvailableOptionByNameAndId('accessory', id);

        // accessory is included as default option, we cannot remove it
        if (
            selectedAccessory.attributes.isDefault ||
            selectedAccessory.attributes.isBlocked
        ) {
            return false;
        }
        // accessory is included in one of the selected packets, we cannot remove it
        if (selectedPacketsAccessories.includes(id)) {
            return false;
        }
        // same type accessory already selected, cannot add multiple
        if (
            !this.productDataStore.isSelected('accessories', id) &&
            !selectedAccessory.attributes.allowMultiple &&
            typeof AccessoryService.getSelectedAccessoriesWithType(
                selectedAccessory.attributes.accessoryType
            ) !== 'undefined'
        ) {
            return false;
        }
        if (this.productDataStore.isSelected('accessories', id)) {
            this.remove(id);
        } else {
            this.select(id);
        }
        Object.entries(this.validate().accessories).forEach((validationResult) => {
            if (
                Number(validationResult[0]) === id &&
                !validationResult[1]
            ) {
                this.remove(id);
            }
        });

        return true;
    }

    public select(id)
    {
        let selectedAccessories = this.productDataStore.getSelectedOptionByName('accessories');

        if (!this.productDataStore.isSelected('accessories', id)) {
            selectedAccessories.push({
                'id': id,
                'type': this.name,
            });
            this.productDataStore.updateSelectedOption('accessories', selectedAccessories);
        }
        return selectedAccessories;
    }

    public remove(id)
    {
        let selectedAccessories = this.productDataStore.getSelectedOptionByName('accessories');

        if (this.productDataStore.isSelected('accessories', id)) {
            selectedAccessories = selectedAccessories.filter(function(accessory) {
                return accessory.id != id;
            });
            this.productDataStore.updateSelectedOption('accessories', selectedAccessories);
        }
        return selectedAccessories;
    }

    public reset()
    {
        const packets = this.productDataStore.getSelectedOptionByName('packet');
        this.productDataStore.updateSelectedOption('accessories', []);

        packets.forEach((packet) => {
            const packetDetails = this.productDataStore.getAvailableOptionByNameAndId(
                'packet',
                packet.id
            );
            if (packetDetails.relationships.accessories.data) {
                packetDetails.relationships.accessories.data.forEach((accessory) => {
                    this.select(accessory.id);
                });
            }
        });
    }

    public hasIncludedAccessories()
    {
        if (Object.keys(this.productDataStore.getAvailableOptionsByName('includedAccessories')).length > 0) {
            return true;
        }
        return false;
    }

    public hasAdditionalAccessories()
    {
        if (Object.keys(this.productDataStore.getAvailableOptionsByName('accessory')).length > 0) {
            return true;
        }
        return false;
    }

    public static hasSelectedAccessoryWithType(type, id = null)
    {
        let selectedAccessories = new ProductDataStore().getSelectedOption(
            'accessories',
            'accessory'
        );

        return selectedAccessories.some(
            accessory => Number(accessory.id) !== Number(id) &&
            Number(accessory.attributes.accessoryType) === Number(type)
        );
    }

    public static getSelectedAccessoriesWithType(typeId)
    {
        let selectedAccessories = new ProductDataStore().getSelectedOption(
            'accessories',
            'accessory'
        );

        return selectedAccessories.find(
            item => Number(item.attributes.accessoryType) === typeId
        );
    }
}
